import styled from 'styled-components';
import { Modal } from 'react-bootstrap';

export const SuccessPopupStyles = styled(Modal)`
  .check-container {
    display: flex;
    justify-content: center;
    > .check-icon {
      width: 300px;
    }
  }
  .inform-text {
    font-size: 2em;
    font-weight: 700;
    text-align: center;
  }
  @media screen and (max-width: 768px) {
    .modal-content {
      width: 40%;
      margin-left: auto;
      margin-right: auto;
    }
    .inform-text {
      font-size: 1.5em;
      font-weight: 600;
    }
  }
`;
